/* esm.sh - date-fns@4.1.0/_lib/normalizeInterval */
import{normalizeDates as o}from"./normalizeDates.mjs";function m(r,t){let[n,e]=o(r,t.start,t.end);return{start:n,end:e}}export{m as normalizeInterval};
//# sourceMappingURL=normalizeInterval.mjs.map